import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import ApplyNakalaKafala from "./PopupUpdate/PopupUpdate";
import NakalaKaflaPopUp from "./NakalaKaflaPopUp";
import { FaDownload } from "react-icons/fa";
import { useEffect } from "react";
import FilterTab from "../../../../ReusableComponents/FilterDropDown/FilterTab";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import GenerateEmployeePopUp from "./employeePopUp";

export default function ListNakalaKafla({
  token,
  titles = [],
  list = [],
  loading,
  apiCall,
}) {
  const [Popup, setPopUp] = useState(false);
  const [editingIndex, setEditingIndex] = React.useState();
  const [searchWords, setSearchWords] = useState([]);
  const [newPopup, setnewPopUp] = useState(false);
  const [filter, setFiltered] = React.useState([]);
  const [dataList, setDataList] = useState({});
  const dispatch = useDispatch();
  const [trigger, setTrigger] = useState(false);

  function filterStatus(item) {
    if (item === "All") {
      setFiltered(list?.data);
      return;
    }
    setFiltered(list?.data.filter((emp) => emp.nakala_status === item));
  }

  const [Apikey, setApiKey] = useState("");

  const getSearchData = async () => {
    if (Apikey === "") {
      dispatch(
        setAppError({
          msg: "Search filed should not be empty.",
        })
      );
    }
    try {
      const response = await nodeinstance.get(
        `/nakal-kafala/search/${Apikey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setFiltered(response.data.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
      dispatch(
        setAppError({
          msg: "error while getting the search data",
        })
      );
    }
  };

  useEffect(() => {
    // setFiltered(list?.data);
    if (Apikey === "") {
      return;
    } else {
      getSearchData();
    }
  }, [trigger]);

  const update = async (url, type) => {
    try {
      const res = await nodeinstance.post(url, type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        apiCall();
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  // const {
  //   NoDataFound,
  //   Pagination,
  //   PaginationIndex,
  //   Search,
  //   CountPerPage,
  //   currentList,
  // } = useSearchPagination(filter || []);

  //edit text Field
  const handleApply = (index) => {
    setEditingIndex(index);
    setPopUp(filter[index]);
  };

  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  const onSearchChange = (e) => {
    setApiKey(e.target.value);
  };

  const onClearResponse = () => {
    setApiKey("");
    setFiltered([]);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5; // Adjust the number of items per page as needed

  // Calculate total pages
  const totalPages = Math.ceil(filter.length / pageSize);

  // Get current page data
  const currentData = filter.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const [employeePopUp, setEmployeePopUp] = useState(false);
  const [employeeProp, setEmployeeProp] = useState("");

  const HandleEmployeeClick = (id) => {
    setEmployeePopUp(true);
    setEmployeeProp(id);
  };
  return (
    <>
      {Popup.open && (
        <ApplyNakalaKafala
          showPromptElement={addEditPopup}
          setShowPromptElement={setAddEditPopup}
          setUpdateProfessionList={setUpdateProfessionList}
        />
      )}
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 mt-2"
          onClick={() => {
            onClearResponse();
          }}
        >
          <p>Clear filter</p>
        </button>
        <div style={styles.container} className="mt-2">
          <input
            type="text"
            placeholder="Search employee here"
            style={styles.input}
            value={Apikey}
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
          <span
            style={styles.tickIcon}
            onClick={() => {
              getSearchData();
            }}
          >
            ✔️
          </span>
        </div>
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      {/* <CountPerPage /> */}
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[2500px]">
            <div className="grid grid-cols-table-nakala gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-nakala gap-5 p-6 bg-white text-center">
            {filter?.map((list, index) => (
              <React.Fragment key={index}>
                {/* <PaginationIndex index={index} /> */}
                <td className="px-6 whitespace-nowrap">{index + 1}</td>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.employee_id || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.NewEmployeeId || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.name || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.sponsor_id || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client_name || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.new_visa_provider
                        ? list.new_visa_provider : "-"
                    }
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.iqama_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.passport_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.actual_visa_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.visa_profession || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.application_date || "-"}
                  />
                </p>
                {/* <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.current_profession_level || "-"}
                  />
                </p> */}

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      list.fees != ""
                        ? list.fees
                        : list.change_fee || "-"
                    }
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.nakala_status || "-"}
                  />
                </p>
                <div className="pl-16">
                  <FaDownload
                    size={20}
                    onClick={() => {
                      setnewPopUp(true);
                      setDataList(list);
                    }}
                    className="cursor-pointer"
                  />
                </div>
                {list.nakala_status === "Payment Done" ? (
                  <button
                    className="bg-red  rounded-md text-white text-xs p-2 w-20"
                    onClick={() => {
                      HandleEmployeeClick(list);
                    }}
                  >
                    {list.sub_segment === "Changing"
                      ? "Generate employee Id"
                      : "Check"}
                  </button>
                ) : (
                  <button
                    className={
                      list.nakala_status === "Nakal Kafala Completed" ||
                      list.nakala_status === "Pending" ||
                      list.nakala_status === "Completed"
                        ? "bg-red  rounded-md text-white text-xs p-2 w-20"
                        : "rounded-md text-white text-xs p-2 w-20 bg-gray "
                    }
                    disabled={
                      list.nakala_status === "Payment Pending" ? true : false
                    }
                    onClick={() => {
                      if (list.nakala_status === "Nakal Kafala Completed") {
                        update("/nakal-kafala/updatePayment/", {
                          employee_id: list.employee_id,
                          status: "Completed",
                        });
                      } else {
                        handleApply(index);
                      }
                    }}
                  >
                    {list.nakala_status === "Nakal Kafala Completed"
                      ? "Completed"
                      : "Apply"}
                  </button>
                )}
                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="flex justify-center items-center my-4">
        <button
          onClick={goToPreviousPage}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-300 rounded-md mx-2 disabled:opacity-50"
        >
          Previous
        </button>
        <span className="px-4">{`Page ${currentPage} of ${totalPages}`}</span>
        <button
          onClick={goToNextPage}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-gray-300 rounded-md mx-2 disabled:opacity-50"
        >
          Next
        </button>
      </div> */}
      {/* <Pagination /> */}

      {/* Render UpdateForm component */}
      {Popup && editingIndex !== null && (
        <ApplyNakalaKafala
          data={Popup}
          setPopUp={setPopUp}
          onSuccess={apiCall}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      )}

      {newPopup ? (
        <NakalaKaflaPopUp
          PopUp={newPopup}
          setPopUp={setnewPopUp}
          title={""}
          data={dataList}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
      {employeePopUp ? (
        <GenerateEmployeePopUp
          setEmployeePopUp={setEmployeePopUp}
          employeePopUp={employeePopUp}
          employeeProp={employeeProp}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
